"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.path = exports.requestSchema = void 0;
const zod_1 = require("zod");
exports.requestSchema = zod_1.z.object({
    email: zod_1.z.string().email(),
});
exports.path = '/forgot-password';
//# sourceMappingURL=index.js.map